



















































































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import editor from '@/components/common/summernote/Index.vue';
import {PopupRequestData} from '@/types';
import {PostSmsRequest, GetSmsPublicAppkeyValidationRequest, GetMembersRequest, GetSmsAdBlockerRequest, Mall} from 'supporter';
import {i18nObjectByKey} from '@/utils/i18n';
import {ncpPopup} from '@/utils/ncp';
import {addDay} from '@/utils/dateUtils';
import {State, namespace} from 'vuex-class';
import SmsTab from '@/components/manage/sms/SmsTab.vue';
const mallModule = namespace('mall');
@Component({
  components: {
    PageTitle,
    MallsTab,
    CompSelectBox,
    editor,
    DateCalendar,
    SmsTab
  }
})
export default class SmsDispatch extends Vue {
  // 쇼핑몰
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private smsUsed: boolean = false;
  private memberCount: number = 0;
  private memberNoList: number[] = [];
  private memberList: any[] = [];
  private senderno: string = '';
  private templateNo: number = 0;
  private templateType: string = '';
  private isAd: boolean = false;
  private isMsg: boolean = false;
  private isTemplateUsed: boolean = false;
  private isCheckOn: boolean = false;  
  private sendType: string = 'SMS';
  private adBlockerNo: string = '';
  private isShowNotice: boolean = false;
  private isSendImmediate: boolean = true;
  private recipient: string = 'selectMember';
  private recipientType: string = 'MEMBER_NO';
  private sendInformationType: string = '';
  private title: string = '';
  private content: string = '';
  private previewTitle: string = '';
  private previewContents: string = '';
  private isPreview: boolean = false;
  private isAppKeyConfigured: boolean = false;
  private hasSenderno: boolean = false;
  private attachedFileName: string = '';

  private getMemberRequest: GetMembersRequest = {
    params: {
      mallNo: 0,
      page: 1,
      pageSize: 30,
      types: 'MALL,SYNC_ID,OPEN_ID',
      searchType: 'ALL'
    }
  };

  private getWordCountWithMaxCount(msg, maxByte){
    let ret = 0;
    ret = this.getWordCount(msg, maxByte, true)[1];
    return ret>maxByte?maxByte:ret;
  }

  private getRealWordCount(msg, maxByte, isContent): number[]{
      let letter;
      let msgByte = this.isAd&&isContent?33:0;
      let msgLength = 0;
      const obj = [];

      for (let i = 0; i < msg.length; i++) {
          letter = msg.charAt(i);
          if (escape(letter).length > 4) {
              msgByte += 2;
          } else if (letter !== '\r') {
              msgByte += 1;
          }

          msgLength += 1;
      }
      obj[0] = msgLength;
      obj[1] = msgByte;

      return obj;
  }

  private getWordCount(msg, maxByte, isContent): number[]{
      let letter;
      let msgByte = this.isAd&&isContent?33:0;
      let msgLength = 0;
      const obj = [];

      for (let i = 0; i < msg.length; i++) {
          letter = msg.charAt(i);
          if (escape(letter).length > 4) {
              msgByte += 2;
          } else if (letter !== '\r') {
              msgByte += 1;
          }

          msgLength += 1;
          if (msgByte >= maxByte) {
              obj[0] = msgLength;
              obj[1] = msgByte;
              // obj[1] = maxByte;

              return obj;
          }
      }
      obj[0] = msgLength;
      obj[1] = msgByte;

      return obj;
  }
  private onChangeContent(msg, maxByte): void {
    this.content = this.content.substring(0, this.getWordCount(msg, maxByte, true)[0])
  }
  private onChangeTitle(msg, maxByte): void {
    this.title = this.title.substring(0, this.getWordCount(msg, maxByte, false)[0])
  }

  private sendernoList: any[] = [
    {
      senderno: 'MANAGE_SMS_DISPATCH_PLACEHOLDER_SENDNO'
    }
  ];

  private async getMemberCount() {
    this.getMemberRequest.params.mallNo = Number(this.mallNo);
    this.getMemberRequest.params.status = 'ACTIVE';
    if(this.isAd){
      this.getMemberRequest.params.smsAgreed = true;
    }else{
      this.getMemberRequest.params.smsAgreed = undefined;
    }

    let {data} = await this.$api.getMembers(this.getMemberRequest);
    this.memberCount = data.totalCount;

    // let request = {
    //   params: {
    //     mallNo: Number(this.mallNo)
    //   }
    // };
    // this.$api.getMemberGrades(request).then((res): any => {
    //   res.data.forEach(grade => this.memberCount += grade.memberCount)
    // });    
  }

  private async changeSendInformationType() {
    // if ($('#sendInformationType').prop('selectedIndex') === 2) {
      if(this.sendInformationType === 'AD'){
      this.isAd = true;
      this.isMsg = false;
      // if (!this.adBlockerNo) {
      //   alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SMSBLOCKNO'));
      //   this.sendInformationType = 'INFORMATION';
      // }

      // 2.  GET /sms/public-appkey/validation 返回成功
      // SMS유형 为 ‘광고성’时
      // 查询 GET /sms/ad-blocker 返回数据 (adBlockerNo is not empty)时  可填写内容发送操作 (avilable)状态
      // 查询 GET /sms/ad-blocker 失败，无数据时, alert ‘080 수신거부 번호 등록이 필요합니다.’
      if(this.isAd && this.isAppKeyConfigured){
        await this.getCallerid();
        if(this.senderno && this.senderno.length > 0){
          await this.getAdBlockerNo();
          if(this.adBlockerNo && this.adBlockerNo.length > 0){
            this.isCheckOn = true;
          }else{
            alert(this.$t('MANAGE_SMS_DISPATCH_ERR_BLOCKER'));
          }
        }else{
          alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SENDNO'));
        }

        let maxWordC = this.sendType==='SMS'?90:2000;
        if(this.getRealWordCount(this.content, maxWordC, true)[1] > maxWordC){
          this.content = this.content.substring(0, this.getWordCount(this.content, maxWordC, true)[0])
        }

      }      
    // }else if($('#sendInformationType').prop('selectedIndex') === 1) {
      }else if(this.sendInformationType === 'INFORMATION'){
      this.isMsg = true;
      this.isAd = false;
      this.sendInformationType = 'INFORMATION';
      // 1. GET /sms/public-appkey/validation 返回 ➞ 400 T0002: 사용할 수 없는 앱키 时
      // alert此信息 '정보성/광고성 SMS를 모두 발송할수 없습니다. 앱키를 등록해주세요.'
      // 返回成功 但是 발신번호(sendNo) 无数据时 alert '발신번호를 등록해주세요'
      // 返回成功  + SMS유형 为 ‘정보성’ + 발신번호(sendNo) 有数据时 可填写内容发送操作 (avilable)状态
      if(this.isMsg && this.isAppKeyConfigured){
        await this.getCallerid();
        if(this.senderno && this.senderno.length > 0){
          this.isCheckOn = true;
        }else{
          alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SENDNO'));
        }
      }      
    }else {
      this.isAd = false;
      this.isMsg = false;
    }
  }

  private changeTemplate() {
    if (!this.isTemplateUsed) {
      this.title = '';
      this.content = '';
    }
  }

  private doRecipientRadio(value: string) {
    this.memberCount = 0;
    if (value === 'selectMember') {
      $('#memberBtnWrap').show();
      $('#excelBtnWrap').hide();
    } else if (value === 'all') {
      $('#memberBtnWrap').hide();
      $('#excelBtnWrap').hide();
      this.getMemberCount();
      $('#recipientsTargetType').val('ALL');
      $('#recipients').val('');
    } else {
      $('#memberBtnWrap').hide();
      $('#excelBtnWrap').show();
    }
  }

  private doSendImmediate() {
    if (this.isSendImmediate) {
      // $('.date-picker').prop('disabled', true);
      $('.timepicker').prop('disabled', true);
    } else {
      // $('.date-picker').prop('disabled', false);
      $('.timepicker').prop('disabled', false);
    }
  }

  private startYmd: string = addDay(new Date(), 0);
  private calendarOption = {
    fromRanges: addDay(new Date(), 0)
  };

  private selectHour: string = '00';
  private get hourList() {
    let hours = [];
    for (let i = 0; i <= 23; i++) {
      let j = '';
      if (i < 10) {
        j = '0' + i;
      } else {
        j = '' + i;
      }
      hours.push({
        value: j,
        name: j
      });
    }
    return hours;
  }

  private selectMinute: string = '00';
  private get minuteList() {
    let minute = [];
    for (let i = 0; i <= 5; i++) {
      let j = '' + i + '0';
      minute.push({
        value: j,
        name: j
      });
    }
    return minute;
  }

  private onReset(): void {
    this.isAppKeyConfigured = false;
    this.getAppKeyConfigured();
    this.sendInformationType = '';
    this.isCheckOn = false;
    this.isAd = false;
    this.isMsg = false;
    this.sendernoList = [
    {
      senderno: 'MANAGE_SMS_DISPATCH_PLACEHOLDER_SENDNO'
    }      
    ];
    this.senderno = this.sendernoList[0].senderno;
    this.adBlockerNo = '';
    this.changeSendInformationType();
    this.isTemplateUsed = false;
    this.sendType = 'SMS';
    this.recipient = 'selectMember';
    this.doRecipientRadio(this.recipient);
    this.memberCount = 0;
    this.memberNoList = [];
    this.memberList = [];
    this.isSendImmediate = true;
    this.doSendImmediate();
    this.title = '';
    this.startYmd = addDay(new Date(), 0);
    this.selectHour = '00';
    this.selectMinute = '00';
    this.content = ' ';
    this.$nextTick(() => {
      this.content = '';
    });
  }

  private onPreview(): void {
    if (this.isAd) {
      this.previewContents = this.$t('MANAGE_SMS_DISPATCH_TITLE_AD') + '\n' + this.content + '\n' + this.$t('MANAGE_SMS_DISPATCH_CONTENT_AD') + this.adBlockerNo;
    } else {
      this.previewContents = this.content;
    }

    if (this.sendType === 'SMS') {
      this.previewTitle = '';
    } else {
      this.previewTitle = this.title;
    }
    this.isPreview = true;
  }

  private onSave1(): void {
    let request = {
      data: {
        inquiryTypeNo: 123,
        reason: 'test',
        assigneeNo: 0,
        mallNo: 2100,
        inquiryNos: this.memberNoList
      }
    };
    this.$api.putInquiries(request).then(() => {
      alert(this.$t('MANAGE_SMS_DISPATCH_SUCCESS_SEND'));
      // this.onReset();
    });
  }

  private onSave(): void {
    let maxContentLength = this.sendType === 'SMS' ? 90 : 2000;
    if (this.isFormPassed()) {
      let request: PostSmsRequest = {
        params: {
          mallNo: this.mallNo
        },
        data: {
          templateNo: this.isTemplateUsed?this.templateNo:null,
          recipientType: this.recipient === 'all'?'ALL':this.recipientType,
          messageType: this.sendInformationType === '' ? 'INFORMATION' : this.sendInformationType,
          recipients: this.memberNoList,
          requestDateTime: this.isSendImmediate?null:(this.startYmd + ' ' + this.selectHour + ':' + this.selectHour + ':00'),
          title: this.title.length > 40 ? this.title.substr(0, 40) : this.title,
          content: this.isAd && this.content.length > maxContentLength ? this.content.substr(0, this.content.length - (1 + 26)) : this.content,
          adBlockerNo: this.adBlockerNo,
          smsType: this.sendType,
          outboundCallerId: this.senderno
        }
      };
      this.$api.postSms(request).then(() => {
        alert(this.$t('MANAGE_SMS_DISPATCH_SUCCESS_SEND'));
        this.onReset();
      });
    }
  }

  private isFormPassed(): boolean {
    // Email Appkey 확인
    if (!this.isAppKeyConfigured) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_APP_KEY'));
      return false;
    }

    if (!this.sendType) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SENDTYPE'));
      return false;
    }

    if (this.isTemplateUsed) {
      if (this.templateType === '') {
        alert(this.$t('MANAGE_SMS_DISPATCH_ERR_TEMPLATESENDTYPE_NULL'));
        return false;
      }
      if (this.templateType !== this.sendType) {
        alert(this.$t('MANAGE_SMS_DISPATCH_ERR_TEMPLATESENDTYPE'));
        return false;
      }
    }

    if (!this.senderno) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SENDERNO'));
      return false;
    }

    if (this.memberCount === 0) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_RECIPIENT_COUNT'));
      return false;
    }

    if (!this.isSendImmediate) {
      const _MINUTE_STANDARD = 10;
      const date = this.startYmd.split('-');
      const targetDate = new Date(parseInt(date[0]), parseInt(date[1]) - 1, parseInt(date[2]), parseInt(this.selectHour), parseInt(this.selectMinute));
      const now = new Date();
      targetDate.setMinutes(targetDate.getMinutes() - _MINUTE_STANDARD);
      if (targetDate.getTime() - now.getTime() < 0) {
        alert(this.$t('MANAGE_SMS_DISPATCH_ERR_TIME'));
        return false;
      }
    }
    if (this.sendType === 'LMS' && !this.title) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_TITLE'));
      return false;
    }
    if (!this.content) {
      alert(this.$t('MANAGE_SMS_DISPATCH_ERR_SUMMERNOTE'));
      return false;
    }
    return true;
  }

  private getAppKeyConfigured(): void {
    let request: GetSmsPublicAppkeyValidationRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    this.$api.getSmsPublicAppkeyValidation(request).then(() => {
        this.isAppKeyConfigured = true;
        // let sendno: string =  res.data.sendNo;
        // if(sendno && sendno.length > 0){
        //   this.hasSenderno = true;
        // }
      })
      .catch((e: any) => {
        if (e.data.code === 'T0002') {
          alert(this.$t('MANAGE_SMS_DISPATCH_ERR_APPKEY'));
        }
      }); 
   
  }

  private async getAdBlockerNo() {
    let request: GetSmsAdBlockerRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    await this.$api.getSmsAdBlocker(request).then(ret => {
      this.adBlockerNo = ret.data.adBlockerNo;
    });
  }

// 10. 수동발송 발신번호 조회
// GET /sms/outbound-caller-id/public
// https://docs.e-ncp.com/?urls.primaryName=manage-api#/SMS/get-public-outbound-caller-id-list
  private async getCallerid() {
    let request = {
      params: {
        mallNo: this.mallNo
      }
    };
    await this.$api.getSmsOutboundcalleridPublic(request).then(ret => {
      this.sendernoList = [];
      ret.data.sendNos.forEach((elem: string) => {
        this.sendernoList.push({
          // senderno: elem.replace(/-/gi, '')
          senderno: elem
        });
      });
      this.senderno = this.sendernoList[0].senderno;
    });
  }

  private excelDown() {
    // let url = '/storage?container=excel-sample&fileName=sms_recipient_template.xlsx';
    // window.location.assign(url);

      const params = {fileName: 'sms_recipient_template.xlsx', container: 'excel-sample'};
      this.$api.getStorage({params,responseType: 'blob'}).then(res => {
          const blob = new window.Blob([res.data], {type: 'blob'});
          if ('download' in document.createElement('a')) {
            // 非IE下载
            const elink = document.createElement('a');
            elink.download = 'sms_recipient_template.xlsx';
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, 'sms_recipient_template.xlsx');
          }
        })
        .catch();    

  }

  // private excelUpload(): void {
  //   const file = Array.from((this.$refs.addExcelFile as HTMLInputElement).files as FileList)[0];
  //   if (!file.name.toLowerCase().match(/\.(xlsx)$/)) {
  //     alert(this.$t('MAIL_DISPATCH_ERR_EXCELTYPE'));
  //     return;
  //   } else {
  //     const data = new FormData();
  //     data.append('file', file);
  //     axios({
  //       headers: {
  //         Version: process.env.VUE_APP_API_VERSION,
  //         'Content-Type': 'multipart/form-data',
  //         accessToken
  //       },
  //       data,
  //       method: 'post',
  //       url: `${process.env.VUE_APP_API_URL}/mail/recipient/excel?mallNo=${this.mallNo}`
  //     })
  //       .then((res: any) => {
  //         const memberNos = res.data;
  //         this.recipientType = 'MEMBER_NO';
  //         memberNos.forEach((member: any) => {
  //           this.memberNoList.push(Number(member.memberNo));
  //         });

  //         this.memberCount = this.memberNoList.length;
  //         this.attachedFileName = file.name;
  //       })
  //       .catch(() => {
  //         alert(this.$t('MAIL_DISPATCH_ERR_EXCEL'));
  //       });
  //   }
  // }

  private excelUpload() {
    const file = Array.from((this.$refs.addExcelFile as HTMLInputElement).files as FileList)[0];
    if (file) {
      this.uploadFile(file, (data: any) => {
          const memberNos = data.data.memberNos;
          this.recipientType = 'MEMBER_NO';
          memberNos.forEach((memberNo: any) => {
            this.memberNoList.push(memberNo);
          });
          this.memberCount = this.memberNoList.length;
          this.attachedFileName = file.name;
      });
    }
  }

  private uploadFile(file: any, callback: Function): void {
    if (!file.name.toLowerCase().match(/\.(xlsx)$/)) {
      alert(this.$t('MAIL_DISPATCH_ERR_EXCELTYPE'));
      return;
    }
    // if (file.size > 10240) {
    //   alert(this.$t('PRODUCT_STICKER_ALERT'));
    //   return;
    // }
    const data = new FormData();
    data.append('file', file);
    data.append('name', 'excelFile');
    data.append('filename', file.name);
    data.append('excelFile', file);
    this.$api.postSmsRecipientExcel({data, params: {mallNo: Number(this.mallNo)}}).then((res) => {
      callback(res);
    });
    // axios({
    //   headers: {
    //     Version: '1.0',
    //     'Content-Type': 'multipart/form-data',
    //     accessToken
    //   },
    //   data,
    //   method: 'post',
    //   url: `${process.env.VUE_APP_API_URL}/images?mallNo=${this.mallNo}`
    // }).then((request: any) => {
    //   callback(request.data);
    // });
  }


  private openPop(type: string) {
    let queryString = '?mallNo=';

    switch (type) {
      case 'select':
        (window as any).membersCallback = this.callbackSelect;
        queryString += this.mallNo + '&callback=membersCallback';
        ncpPopup(`/member/popup/recipient${queryString}`, this.$t('MANAGE_SMS_DISPATCH_POPUP_MEMBER_SELECT'), 635, 500);
        break;
      case 'search':
        if (!this.memberList || this.memberList.length > 0) {
          sessionStorage.setItem('checkedMembersInfo', JSON.stringify(this.memberList));
        }
        (window as any).membersCallback = this.callbackSearch;
        ncpPopup(`/member/list/popup/${this.mallNo}?callback=membersCallback`, this.$t('MANAGE_SMS_DISPATCH_POPUP_MEMBER_SEARCH'), 1275, 980);
        break;
      case 'template':
        (window as any).membersCallback = this.callbackForTemplate;
        queryString += this.mallNo + '&callback=membersCallback';
        ncpPopup(`/sms/popup/template-list${queryString}`, this.$t('MANAGE_SMS_DISPATCH_TEMPLATE_INUSE'), 600, 400);
        break;
    }
  }

  private callbackSearch(selectedRows: any) {
    (window as any).membersCallback = undefined;
    sessionStorage.removeItem('checkedMembersInfo');
    this.recipientType = selectedRows.selectedType;
    this.memberList = selectedRows.selectedMembers;
    this.memberList.forEach((member: any) => {
      this.memberNoList.push(Number(member.memberNo));
    });
    this.memberCount = selectedRows.memberCount;
    // this.search(this.getMemberRequest.params.page);
  }

  private selectedDate: any = '';
  private callbackSelect(data: any) {
    (window as any).membersCallback = undefined;
    this.selectedDate = JSON.stringify(data);
    this.recipientType = data.GroupOrGrade;
    if(this.recipientType === 'GRADE'){
      this.memberCount = data.gradeCount;
      this.memberList = data.GRADE;
    }else if(this.recipientType === 'GROUP'){
      this.memberCount = data.groupCount;
      this.memberList = data.GROUP;
    }
  }

  private callbackForTemplate(mailTemplatesCustom: any) {
    (window as any).membersCallback = undefined;
    this.title = mailTemplatesCustom.title;
    this.templateType = mailTemplatesCustom.type;
    this.sendType = mailTemplatesCustom.type;
    this.content = mailTemplatesCustom.content;
    this.templateNo = mailTemplatesCustom.templateNo;
  }

  private dispatchPreviewPopupRequestData: PopupRequestData = {
    id: 'previewcontent',
    width: 280,
    maxHeight: 800,
    title: 'MANAGE_SMS_DISPATCH_TITLE_PREVIEW',
    hasConfirmBtn: false,
    hasCloseBtn: true
  };

  private toFirstPage() {
    const url = `/sms/send-list?mallNo=${this.mallNo}&tabNo=1`;
    window.location.assign(url);
  }

  private async configurations() {
    const configRequest = {
      params: {
        mallNo: this.mallNo
      }
    };

    await this.$api
      .getNotificationsConfigurations(configRequest)
      .then(res => {
        this.smsUsed = res.data.smsUsed;
      })
      .catch((e: any) => {
        if (e.data.code === 'MC0002') {
          this.smsUsed = false;
        }
      });
      if(!this.smsUsed){
        window.location.assign(`/sms/usage-list?mallNo=${this.mallNo}&tabNo=5`);
      }
  }

  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChanged() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    await this.configurations();
    this.doSendImmediate();
    this.onReset();
    this.getAppKeyConfigured();

  }

  private mallIndex: number = 0;


  private created() {
    this.dispatchPreviewPopupRequestData = i18nObjectByKey(this, this.dispatchPreviewPopupRequestData, 'title');
  }

  private async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.toFirstPage();
    return;
    await this.configurations();    
    this.doSendImmediate();
    this.getAppKeyConfigured();
    this.senderno = this.sendernoList[0].senderno;
    // this.getAdBlockerNo();
    // this.getCallerid();
  }
}
